import * as actions from './types';

export const menuUriHandler = menuUri => dispatch => {
    dispatch({
        type: actions.MENU_URI,
        payload: menuUri
    })
}